<div class="modal-header bg-light py-3">
  <h5 class="modal-title">
    <i class="ri-eye-line align-middle me-2 text-primary"></i>
    {{ 't-impersonate-title' | translate }}
  </h5>
  <button type="button" class="btn-close" aria-label="Close" [disabled]="submitting"
    (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <p class="text-muted fs-13">{{ 't-impersonate-hint' | translate }}</p>

  <ng-select [items]="users" bindValue="id" bindLabel="name" [(ngModel)]="userId" [searchFn]="searchUser"
    [loading]="loading" [disabled]="submitting" appendTo="body"
    placeholder="{{ 't-impersonate-select-user' | translate }}"
    notFoundText="{{ 't-impersonate-no-users' | translate }}">
    <ng-template ng-option-tmp let-item="item">
      <span class="d-flex align-items-center justify-content-between w-100">
        <span class="overflow-hidden">
          <span class="d-block text-truncate">{{ item.name }}</span>
          <span class="d-block fs-12 text-muted text-truncate">{{ item.email }}</span>
        </span>
        <span class="badge badge-soft-primary ms-2 flex-shrink-0">{{ item.role?.name }}</span>
      </span>
    </ng-template>
  </ng-select>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" [disabled]="submitting" (click)="activeModal.dismiss()">
    {{ 't-cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" [disabled]="!userId || submitting" (click)="confirm()">
    <span *ngIf="submitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
    {{ 't-impersonate-confirm' | translate }}
  </button>
</div>
